<template>
  <v-container fluid class="pt-0">
    <v-container fluid class="container-custom">
      <v-row no-gutters justify="center">
        <v-col sm="10">
          <Breadcrumbs
            :title="$t('modules.settings.expiration.breadcrumbs.title')"
            :description="$t('modules.settings.expiration.breadcrumbs.description')"
          ></Breadcrumbs>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col sm="10" class="viewSpaces">
          <template >
            <OutlinedCard :section="$t('modules.settings.expiration.sectionSecurity.title')" class="mb-6">
              <OutlinedCardContent
                :label="$t('modules.settings.expiration.sectionSecurity.actualExpirationDate')"
                sm="4"
              >
                <v-text-field
                  v-model=actualExpirationDate
                  placeholder="Cargando..."
                  outlined
                  readonly
                ></v-text-field>
              </OutlinedCardContent>
              <OutlinedCardContent
                :label="$t('modules.settings.expiration.sectionSecurity.newExpirationDate')"
                sm="4"
              >
                <v-select
                  v-model="newExpirationDate"
                  :items="daysOfMonth"
                  :disabled="!canUpdate"
                  label="Selecciona el día de vencimiento"
                  outlined
                ></v-select>
              </OutlinedCardContent>

            </OutlinedCard>
            <div class="text-sm-right">
              <Button
                :loading="loading"
                :success="success"
                :error="error"
                :text="$t('actions.save')"
                :successText="$t('actions.saved')"
                :errorText="$t('actions.error')"
                @clicked="dataUpdate"
                @end="resetButtonValues"
                :disabled="!canUpdate"
              ></Button>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>

// Components Imports
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard'
import OutlinedCardContent from '@/components/OutlinedCardContent/OutlinedCardContent'
import Button from '@/components/Button/Button'
import {$expirationDate } from '../services'

export default {
  components: {
    Breadcrumbs,
    OutlinedCard,
    OutlinedCardContent,
    Button
  },
  data () {
    return {
      newExpirationDate: null,
      actualExpirationDate: null,
      loading: false,
      success: false,
      error: false,
      daysOfMonth: Array.from({ length: 28 }, (_, i) => i + 1)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const response = await $expirationDate.find(`expirationDate`, null, null)
        this.actualExpirationDate = response.data.date
      } catch (error) {
        this.error = true
        throw error
      }
    },
    async dataUpdate() {
      try {
        this.loading = true;
        await $expirationDate.create(this.newExpirationDate, null ,`expirationDate?expirationDate=${this.newExpirationDate}`)
        this.actualExpirationDate = this.newExpirationDate;
        this.newExpirationDate = '';
        this.success = true
      } catch (error) {
        this.error = true
        throw error
      } finally {
        this.loading = false
      }
    },
    resetButtonValues () {
      this.loading = false;
      this.success = false;
      this.error = false;
    }
  },
  validations: {
  },
  computed: {
    canUpdate() {
      return this.$permissions.settings.expiration.UPDATE;
    },
  },
}

</script>

